module.exports = __webpack_public_path__ + "static/Naviqb-366e18230bd1b886789d2daf89d0395e.jpg";